import { isVisible, throttle } from '@Foundation/utilities';

export const fadein = { // eslint-disable-line
  name: 'fadein',
  bind: (el, binding) => {
    const checkAnimation = () => {
      /* istanbul ignore else */
      if (isVisible(el)) {
        el.classList.add(`fadein--${binding.value}`);
      }
    };
    el.classList.add('fadein');

    setTimeout(() => {
      checkAnimation();
    }, 300);
    window.addEventListener('scroll', throttle(checkAnimation, 160));
  }
};
